import { useWebSocketContext } from '@crm-src/components/websocket-provider'

export const useWebSocket = () => {
  // Simply return the global WebSocket context
  return useWebSocketContext()
}

export default useWebSocket
